import { useContext } from 'react';
import { useAppStore } from '../store/useAppStore';
import { useAdDataFreshness } from '../hooks/useAdDataFreshness';
import { deliveryFreshnessPlatform } from '../lib/adDataFreshness';
import { useDeliverySiteScope } from '../hooks/useDeliverySiteScope';
import { AdDataFreshnessContext, type AdDataFreshnessScope } from './AdDataFreshnessContext';
import { RequirePagePermission } from './RequirePagePermission';
import './AdDataFreshnessNote.css';

export function AdDataFreshnessNote() {
  const scope = useContext(AdDataFreshnessContext);
  if (!scope) return null;
  return <RequirePagePermission code={'stats:delivery:' + scope.page.split('/').pop()}>
    <DeliveryFreshness {...scope} />
  </RequirePagePermission>;
}

function DeliveryFreshness({ page, active, reportLoading }: AdDataFreshnessScope) {
  const { brandId, siteId } = useAppStore();
  const supported = useDeliverySiteScope();
  const platform = deliveryFreshnessPlatform(page);
  const enabled = active && supported && !!platform;
  const freshness = useAdDataFreshness(brandId, siteId, platform?.platform ?? '', enabled, reportLoading);
  if (!enabled || !platform) return null;
  return <div className="ad-data-freshness-inline" aria-label={platform.label + ' 数据更新时间'} aria-live="polite" aria-busy={freshness.status === 'loading'}>
    <span>数据更新至：</span>
    {freshness.status === 'ready'
      ? <time dateTime={freshness.updatedAt.replace(' ', 'T')}>{freshness.updatedAt}</time>
      : <span>{freshness.status === 'loading' ? '正在获取…' : '暂不可用'}</span>}
  </div>;
}
